import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import {
    CreateTrocaAutomaticaTabelaSchema,
    TrocaAutomaticaTabela,
    trocaHorario,
} from '@/service/api'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import { SubmitHandler } from 'react-hook-form'
import { toast } from 'sonner'
import FormTrocaAutomatica from './forms/FormTrocaAutomatica'

export default function AdicionarTrocaAutomaticaHorario() {
    const { mutateAsync, isLoading } =
        trocaHorario.trocaAutomatica.mutations.useCreate({
            invalidateQuery: true,
        })
    const [empresaId, funcionarioId] = useStore(state => [
        state.companyId,
        state.employeeId,
    ])

    const handleSubmit: SubmitHandler<TrocaAutomaticaTabela> = async data =>
        mutateAsync(
            { ...data, funcionarioId, empresaId },
            {
                onSuccess: () => {
                    toast.success('Troca automática adicionada com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    const now = dayjs.utc()

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateTrocaAutomaticaTabelaSchema}
            open={hasPermission(['create', 'TrocaAutomáticaDeHorário'])}
            defaultValues={{
                dataInicial: now.format('YYYY-MM-DD'),
                tipoRepeticao: 'DIARIO',
                tipoDuracaoRepeticao: 'DIARIO',
                repeticaoSemanalDia: now.day(),
                repeticaoMensalOpcao: 'DIA',
                empresaId,
                duracaoRepeticao: 1,
                every: 1,
            }}
        >
            <Dialog.Title>Adicionar troca automática de horário</Dialog.Title>
            <Dialog.Content dividers>
                <FormTrocaAutomatica />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
